import { render, staticRenderFns } from "./MNotesDetail.vue?vue&type=template&id=12219272&scoped=true"
import script from "./MNotesDetail.vue?vue&type=script&lang=js"
export * from "./MNotesDetail.vue?vue&type=script&lang=js"
import style0 from "./MNotesDetail.vue?vue&type=style&index=0&id=12219272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12219272",
  null
  
)

export default component.exports